import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/layout/DashboardLayout";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Departments from "./pages/Departments";
import Jobs from "./pages/Jobs";
import GmView from "./pages/GmView";
import PmView from "./pages/PmView";
import Builder from "./pages/Builder";
import QCPipeline from "./pages/QCPipeline";
import NCRDashboard from "./pages/NCRDashboard";
import QCByPlant from "./pages/QCByPlant";
import CompletionRates from "./pages/CompletionRates";
import LookAhead from "./pages/LookAhead";
import Insights from "./pages/Insights";
import JobForecasting from "./pages/JobForecasting";
import LaborEstimation from "./pages/LaborEstimation";
import UploadData from "./pages/UploadData";
import UsersManagement from "./pages/UsersManagement";
import RolesManagement from "./pages/RolesManagement";
import Configuration from "./pages/Configuration";
import NotificationSettings from "./pages/NotificationSettings";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route path="/" element={<Overview />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/gm-view" element={<GmView />} />
            <Route path="/pm-view" element={<PmView />} />
            <Route path="/builder" element={<Builder />} />
            <Route path="/qc-pipeline" element={<QCPipeline />} />
            <Route path="/ncr" element={<NCRDashboard />} />
            <Route path="/qc-by-plant" element={<QCByPlant />} />
            <Route path="/look-ahead" element={<LookAhead />} />
            <Route path="/completion-rates" element={<CompletionRates />} />
            <Route path="/forecasting" element={<JobForecasting />} />
            <Route path="/labor-estimation" element={<LaborEstimation />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/upload" element={<UploadData />} />
            <Route path="/users" element={<UsersManagement />} />
            <Route path="/roles" element={<RolesManagement />} />
            <Route path="/configuration" element={<Configuration />} />
            <Route path="/notifications" element={<NotificationSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </AuthProvider>
  );
}

export default App;
